/**
 * DOM selectors for sticky add-to-bag functionality.
 * @type {Object<string, string>}
 */
const selectors = {
  atb: '.product-form__submit:not(.quick-add__submit)',
  stickyAtb: '.sticky-atb',
};

document.addEventListener('DOMContentLoaded', () => {

  /**
   * DOM node selectors.
   * @type {Object<string, HTMLElement|null>}
   */
  const nodeSelectors = {
    atb: document.querySelector(selectors.atb),
    stickyAtb: document.querySelector(selectors.stickyAtb),
  };

  /**
   * Tracks whether the main CTA has been visible to prevent premature sticky bar appearance.
   * @type {boolean}
   */
  let hasBeenVisible = false;

  /**
   * Handles intersection observer callback for sticky ATB visibility.
   * Shows sticky bar only after main CTA has been visible and is now out of view.
   * @param {IntersectionObserverEntry[]} entries - Array of intersection observer entries
   */
  const handleIntersection = (entries) => {
    const entry = entries[0];

    // Track if the main CTA has ever been visible
    if (entry.isIntersecting && !hasBeenVisible) {
      hasBeenVisible = true;
    }

    // Only show sticky bar if main CTA was previously visible and is now hidden
    const shouldHide = entry.isIntersecting || !hasBeenVisible;
    nodeSelectors.stickyAtb.classList.toggle('is-hidden', shouldHide);
  };

  /**
   * Intersection Observer for desktop sticky ATB functionality.
   * @type {IntersectionObserver}
   */
  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px -50px 0px',
    threshold: [0]
  });

  /**
   * Initializes the sticky ATB observer after a delay to ensure page layout is complete.
   */
  const initializeStickyATB = () => {
    if (nodeSelectors.atb && nodeSelectors.stickyAtb) {
      observer.observe(nodeSelectors.atb);
    }
  };

  // Small delay to ensure page layout is complete
  setTimeout(initializeStickyATB, 100);

  /**
   * Variant change.
   */
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const idField = nodeSelectors.stickyAtb.querySelector('[name="id"]');
    const priceField = nodeSelectors.stickyAtb.querySelector('.price-item--regular');
    const idVal = event?.data?.variant.id;
    const priceVal = event?.data?.variant.price;

    if (idField) {
      idField.value = idVal;
    }

    if (priceField) {
      priceField.innerHTML = Shopify.formatMoney(priceVal);
    }
  });
});
